import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullCloud3 extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={46} width={74}>
        <g fill="none" fillRule="evenodd" fillOpacity="0.2">
          <g transform="translate(-1238 -250)" fill="#EAF7FC">
            <g transform="translate(-18 44)">
              <g transform="translate(0 68)">
                <path d="M1320.99761,163.871028 L1319.1864,163.871028 C1319.37843,163.112138 1319.48909,162.319898 1319.48909,161.49675 C1319.48909,156.454561 1315.65431,152.366476 1310.92208,152.366476 C1309.20281,152.366476 1307.60479,152.911446 1306.26307,153.841148 C1305.03607,145.223308 1299.11019,138.686113 1291.9801,138.686113 C1284.35287,138.686113 1278.10397,146.166024 1277.51081,155.672083 C1276.59789,155.08075 1275.57675,154.739941 1274.49214,154.739941 C1270.68585,154.739941 1267.60045,158.828839 1267.60045,163.871028 L1264.70708,163.871028 C1259.96183,163.871028 1256.07986,168.094949 1256.07986,173.257519 L1256.07986,173.948085 C1256.07986,179.110655 1259.96183,183.334576 1264.70708,183.334576 L1320.99761,183.334576 C1325.74287,183.334576 1329.62564,179.110655 1329.62564,173.948085 L1329.62564,173.257519 C1329.62564,168.094949 1325.74287,163.871028 1320.99761,163.871028" />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullCloud3.displayName = "NullCloud3";
NullCloud3.vstuiName = "Icon";

export default NullCloud3;
